import { render, staticRenderFns } from "./OrderQuery.vue?vue&type=template&id=568aa194"
import script from "./OrderQuery.vue?vue&type=script&lang=js"
export * from "./OrderQuery.vue?vue&type=script&lang=js"
import style0 from "./OrderQuery.vue?vue&type=style&index=0&id=568aa194&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports